package dev.danko.roblox_craft_ai.uikit.i18n

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.browser.document
import kotlinx.browser.localStorage
import kotlinx.browser.window

enum class AppLocale(val code: String, val nativeName: String, val shortLabel: String) {
    RU("ru", "Русский", "RU"),
    EN("en", "English", "EN"),
    UK("uk", "Українська", "UK"),
    DE("de", "Deutsch", "DE");

    val strings: AppStrings
        get() = when (this) {
            RU -> RuStrings
            EN -> EnStrings
            UK -> UkStrings
            DE -> DeStrings
        }

    companion object {
        val DEFAULT = EN

        fun fromCode(code: String?): AppLocale? {
            val normalized = code?.trim()?.lowercase()?.substringBefore('-')?.substringBefore('_') ?: return null
            return entries.firstOrNull { it.code == normalized }
        }
    }
}

object LocaleController {
    private const val STORAGE_KEY = "robloxCraft.locale"

    var current: AppLocale by mutableStateOf(detectInitialLocale())
        private set

    val strings: AppStrings
        get() = current.strings

    init {
        applyDocumentLanguage(current)
    }

    fun select(locale: AppLocale) {
        current = locale
        runCatching { localStorage.setItem(STORAGE_KEY, locale.code) }
        applyDocumentLanguage(locale)
    }

    private fun detectInitialLocale(): AppLocale {
        val saved = runCatching { localStorage.getItem(STORAGE_KEY) }.getOrNull()
        AppLocale.fromCode(saved)?.let { return it }
        val browserLanguages = runCatching {
            val list = window.navigator.asDynamic().languages
            if (list != null && list != undefined) {
                (0 until (list.length as Int)).map { list[it] as String }
            } else {
                listOf(window.navigator.language)
            }
        }.getOrDefault(emptyList())
        return browserLanguages.firstNotNullOfOrNull { AppLocale.fromCode(it) } ?: AppLocale.DEFAULT
    }

    private fun applyDocumentLanguage(locale: AppLocale) {
        runCatching { document.documentElement?.setAttribute("lang", locale.code) }
    }
}

@Composable
fun strings(): AppStrings = LocaleController.current.strings
